import { graphql } from "react-relay";

export const SetAwsAccessRolesMutation = graphql`
  mutation SetAwsAccessRolesMutation($input: AWSAccessRoleInput!) {
    setAWSAccessRoles(input: $input) {
      accountDiscovery {
        arn
        error
      }
      primary {
        arn
        error
      }
      readOnly {
        arn
        error
      }
      remediationPolicy {
        arn
        error
      }
    }
  }
`;
